// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const DatabaseErrorOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 -0.5 17 17","focusable":"false"},"children":[{"tag":"g","attrs":{"fill-rule":"evenodd","fill":"#434343","transform":"translate(2)"},"children":[{"tag":"ellipse","attrs":{"cx":"6.43","cy":"2.42","rx":"6.43","ry":"2.42"}},{"tag":"path","attrs":{"d":"M8.57 11.83l1.02-1.01c-.93.16-2 .26-3.13.26-3.51 0-6.44-.98-6.44-1.64v3.27c0 1.2 2.88 2.15 6.44 2.15.93 0 1.81-.07 2.6-.18l1.18-1.18-1.67-1.67zM6.5 9.92c3.55 0 6.44-.98 6.44-2.2V4.38c0 .67-2.93 1.67-6.45 1.67-3.51 0-6.44-1-6.44-1.67v3.34c0 1.22 2.88 2.2 6.44 2.2z"}},{"tag":"path","attrs":{"d":"M15 11.8l-.82-.82-1.7 1.7-1.68-1.66-.81.81 1.67 1.67-1.69 1.69.82.81 1.68-1.69 1.7 1.7.82-.8-1.7-1.7 1.7-1.71z"}}]}]},"name":"database-error","theme":"outlined"};

const DatabaseErrorOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={DatabaseErrorOutlinedSvg} />;
  DatabaseErrorOutlined.displayName = 'DatabaseErrorOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(DatabaseErrorOutlined);
